import styled from 'styled-components';
import Card from 'components/common/Card';
import Link from 'components/common/Link';
import Heading from 'components/common/Typography/Heading';
import Text from 'components/common/Text';

export const CardWrapper = styled(Card)`
  display: flex;
  overflow: hidden;
`;

export const AppWrapper = styled.div`
  width: 50%;
  display: flex;
  justify-content: center;
  flex-direction: column;
  padding: 60px 20px;
  @media (max-width: 876px) {
    width: 100%;
  }
`;

export const GetAppTitle = styled(Heading)`
  color: ${({ theme }) => theme.colors.text};
  font-size: 36px;
  font-weight: 600;
`;

export const Texts = styled(Text)`
  margin: 0 0 16px;
  color: ${({ theme }) => theme.colors.neutral.n9};
  font-weight: 400;
`;

export const EventWrapper = styled.div`
  width: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  //   overflow: hidden;
  position: relative;
  @media (max-width: 876px) {
    display: none;
  }
`;

export const SVGWrapper = styled.svg`
  position: absolute;
  left: -20px;
`;

export const DownloadContainer = styled.div``;
export const DownloadButton = styled(Link)``;
export const DownloadButtonWrap = styled.div`
  display: inline-block;
  &:not(:last-child) {
    margin-right: 10px;
  }
`;

export const ImageMockup = styled.div`
  > span {
    position: absolute !important;
    top: 10px;
    left: 50%;
    transform: translateX(-50%);
    width: 201px !important;
    height: 392px !important;
  }
  > span > img {
    bottom: 80px !important;
  }
`;
export const ImageEventCard = styled.div`
  > span {
    position: absolute !important;
    top: 50%;
    left: 50%;
    transform: translate(-14%, -39%);
    width: 210px !important;
    height: 250px !important;
  }
`;
